import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import BasicModal from 'js/common/components/basic_modal';

const { $, LP } = window;

const Share = LP.module('Share');

const LinkShareModal = (props) => {
  const [url, setUrl] = useState(props.data.url);
  const [activeBtn, setActiveBtn] = useState('full-url');

  useEffect(() => {
    setUrl(props.data.url);
    setActiveBtn('full-url');
  }, [props.data.url]);

  const closeModal = () => {
    props.closePopover();
  };

  const fullUrl = () => {
    setUrl(props.data.url);
    setActiveBtn('full-url');
  };

  return (
    <BasicModal.Container id="js-link-share-modal">
      <BasicModal.Header onClose={closeModal}>
        <h3>Share a Link to this Resource</h3>
      </BasicModal.Header>
      <BasicModal.Body>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-offset-1 col-md-10">
                <label htmlFor="js-link-share" className="control-label">
                  Link (copy this link to share with others)
                </label>
                <textarea
                  type="textarea"
                  id="js-link-share"
                  className="no-resize form-control"
                  value={url}
                  readOnly
                />
                <div className="btn-group mt10">
                  <button
                    onClick={fullUrl}
                    type="button"
                    className={`btn btn-default ${activeBtn === 'full-url' ? 'active' : ''}`}
                  >
                    Full URL
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BasicModal.Body>
      <BasicModal.Footer>
        <div className="btn btn-default" onClick={closeModal}>
          Cancel
        </div>
      </BasicModal.Footer>
    </BasicModal.Container>
  );
};

LinkShareModal.propTypes = {
  data: PropTypes.object,
  closePopover: PropTypes.func
};

Share.LinkShareModal = LinkShareModal;
